module.exports = __webpack_public_path__ + "static/media/quickstart-step-2.ea6103ca.jpg";